// extracted by mini-css-extract-plugin
export default {"container":"AuthCard_container__JUm0w","card":"AuthCard_card__TqLET"};